import { Component, OnInit } from '@angular/core';
import { AnalyticsService, SaComponent } from 'smartauction-frontend-micro-library';
import { DateUtilsService, UserProfile } from 'remarketing-angular-library';
import { Store } from '@ngxs/store';
import {
  CsvDashboardWidgetComponent
} from '../csv-dashboard-widget/csv-dashboard-widget.component';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
    selector: 'csv-file-dashboard',
    templateUrl: './csv-file-dashboard.component.html',
    styleUrls: ['./csv-file-dashboard.component.scss'],
    imports: [CsvDashboardWidgetComponent, CommonModule],
    providers: [DatePipe]
})
export class CsvFileDashboardComponent extends SaComponent implements OnInit {
  userProfile: UserProfile;
  userName: string;
  currentDate = new Date();

  constructor(
    readonly store: Store,
    private readonly analyticsService: AnalyticsService,
    private readonly dateUtilService: DateUtilsService
  ) {
    super();
  }
  ngOnInit() {
    this.userProfile = this.store.selectSnapshot(state => state.user.userProfile);
    this.userName = this.userProfile.userName.split(' ')[0];
  }

  get date() {
    return this.dateUtilService.localizeDate(this.currentDate);
  }
}
